var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Mute component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMute extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.32514 1.32514C1.61803 1.03225 2.09291 1.03225 2.3858 1.32514L22.6758 21.6151C22.9687 21.908 22.9687 22.3829 22.6758 22.6758C22.3829 22.9687 21.908 22.9687 21.6151 22.6758L1.32514 2.3858C1.03225 2.09291 1.03225 1.61803 1.32514 1.32514Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.8258 3.47318C16.2316 3.44072 16.6388 3.51602 17.0061 3.69148C17.0236 3.69985 17.0408 3.7089 17.0576 3.7186C17.4172 3.92607 17.7141 4.22651 17.9174 4.5883C18.1191 4.94728 18.2213 5.35366 18.2132 5.76539V17.4631C18.2132 17.8773 17.8774 18.2131 17.4632 18.2131C17.049 18.2131 16.7132 17.8773 16.7132 17.4631V5.75732L16.7134 5.73937C16.7169 5.59391 16.6811 5.45011 16.6097 5.3231C16.5431 5.20451 16.4479 5.10481 16.333 5.0329C16.2112 4.98001 16.0781 4.95779 15.9455 4.9684C15.8038 4.97973 15.6677 5.02809 15.5506 5.10861L9.3101 9.49256C8.97116 9.73067 8.50337 9.64893 8.26527 9.30999C8.02716 8.97105 8.10891 8.50326 8.44784 8.26516L14.6953 3.87631C15.03 3.64472 15.42 3.50565 15.8258 3.47318Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.26993 14.6835C8.51166 14.3471 8.9803 14.2704 9.31666 14.5121L15.4193 18.8979C15.7556 19.1396 15.8323 19.6082 15.5906 19.9446C15.3489 20.281 14.8802 20.3577 14.5439 20.1159L8.44127 15.7302C8.10491 15.4885 8.0282 15.0198 8.26993 14.6835Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.00586 9.69702C5.42007 9.69702 5.75586 10.0328 5.75586 10.447V13.6894C5.75586 14.0483 6.04687 14.3394 6.40586 14.3394H8.13883V12.7972C8.13883 12.383 8.47462 12.0472 8.88883 12.0472C9.30304 12.0472 9.63883 12.383 9.63883 12.7972V15.0894C9.63883 15.5036 9.30304 15.8394 8.88883 15.8394H6.40586C5.21845 15.8394 4.25586 14.8768 4.25586 13.6894V10.447C4.25586 10.0328 4.59165 9.69702 5.00586 9.69702Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMute.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMute.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMute.prototype, "size", void 0);
if (customElements.get('cat-icon-mute') === undefined) {
    customElements.define('cat-icon-mute', BlocksIconMute);
}
